// Action Types
export var JoinAction;
(function (JoinAction) {
    JoinAction["CREATE"] = "create";
    JoinAction["JOIN"] = "join";
    JoinAction["JOIN_AUDIENCE"] = "join_audience";
    JoinAction["RECONNECT"] = "reconnect";
})(JoinAction || (JoinAction = {}));
//# sourceMappingURL=events.js.map